module.exports = __webpack_public_path__ + "img/human_44.e6ede906.png";